const baseurl="https://zomani.api-apx.com/api/"

export const SubscribeEndpoint=baseurl+"v1/Add_New_AddOn"
export const VerifyEndpoint=baseurl+"v1/Verify_Purchase"
export const ChangePlanEndpoint=baseurl+"v1/UpgradeSubscription"
export const CancelSubEndpoint=baseurl+"v1/Cancel_Subscription"